import { Component, Input } from '@angular/core';

@Component({
    selector: 'base-info',
    template: `
    <div class="class">
        <b>{{text}}: </b>{{value}}{{extraValue}}
    </div>
    `})
export class BaseInfoComponent {
    @Input() value: string;
    @Input() text: string;
    @Input() class: string;
    @Input() extraValue: string;
}


// WEBPACK FOOTER //
// ./src/app/base/base-info.component.ts